import { get } from '../../utils/object-helpers';
import { sendCategoryFilterEvent } from '../../utils/event-triggers';
import { itemCardPropertyRearrange } from './item-card.helpers';

export default class {
    onInput(input) {
        return Object.assign(input, updateInput(input));
    }
    fetchCategoryListings(url, evt) {
        sendCategoryFilterEvent({ url, clickEvent: evt });
    }
}

function updateInput(input) {
    const quickviewFlag = get(input, 'moreOptions.action.clientPresentationMetadata.sf-quickview-atc-btn', null);
    let isSmall = get(input, 'isSmall', null);
    // Sometimes 'isSmall' is not passed in on input (TODO: See if we can always use page.isSmall instead.)
    if (isSmall === null) {
        isSmall = get(input, 'page.isSmall', false);
    }
    const action = get(input, 'action', {});
    const title = get(input, 'title', {});
    title.action = action;

    return {
        __signal: getSignalData(input),
        testId: getTestId(input),
        itemCardWatch: getWatchData(input),
        trackingData: setTrackingData(input),
        propertyOrdering: arrangePropertyOrdering(input),
        openLinkInNewTab: get(input, 'action.name', '') === 'VIEW_ITEM' && !isSmall,
        isAjax: get(input, 'action.clientPresentationMetadata.ajax') === 'true',
        eekIcon: get(input, '__search.eekIcon', get(input, 'eekIcon', null)),
        sid: get(input, 'action.trackingList.[0].eventProperty.sid', ''),
        isQuickviewEnabled: quickviewFlag === '3' && !isSmall,
        imageSize: get(input, 'imageSize', 300),
        link: get(input, 'action.URL', null),
        itemId: get(input, 'listingId', ''),
        action: get(input, 'action', {}),
        isSmall
    };
}

function getTestId(input) {
    const testId = get(input, 'testId', '');
    const testIdAttr = {};

    if (testId !== '') {
        testIdAttr['data-testid'] = testId;
    }

    return testIdAttr;
}

function setTrackingData(input) {
    let trackingData = get(input, 'action.trackingList.[1]', {});

    if (!Object.keys(trackingData).length) {
        trackingData = get(input, 'action.trackingList.[0]', {});
        return trackingData;
    }

    trackingData = JSON.stringify(trackingData);
    return trackingData;
}

function getWatchData(input) {
    return (
        get(input, '__search.defaultWatchIconAtCorner', null) ||
        get(input, '__search.defaultWatchIconOnImage', null)
    );
}

function getSignalData(input) {
    const hasUrgencySignal = get(input, '__search.hasUrgencySignal', false);
    return hasUrgencySignal && !input.simplified && input.itemHotness ? {
        ...input.itemHotness,
        status: 'time-sensitive'
    } : null;
}

export function arrangePropertyOrdering(input) {
    const propertyOrdering = get(input, 'itemPropertyOrdering.DEFAULT', {});
    const propertyMutations = get(input, 'itemPropertyOrdering._mutations', []);
    const __signal = getSignalData(input);

    return itemCardPropertyRearrange(propertyOrdering, [
        { // Make sure we have an image in the header to preserve layout even if the image is broken
            propertyName: 'image',
            newSection: 'header',
            createIfMissing: true
        },
        __signal && { // Reorder where __signal is rendered
            propertyName: 'itemHotness',
            newSection: 'header',
            position: 1,
            newName: '__signal'
        },
        ...propertyMutations
    ]);
}
